import React, { useState } from "react";
import RichTextRenderer from "../../../utils/components/RichTextRenderer";
import { Link } from "gatsby";
import * as styles from "../css/careersDetails.module.css";
import Seo from "../../../utils/components/seo";
import { Popup } from "../../../components/popup";
import { useRef } from "react";
import {
  RenderSvg,
  ScreenSize,
  baseUrl,
  handleCopy,
} from "../../../utils/helpers/helper";
import BackgroundWave from "../../../components/layoutSections/BackgroundWave";

export default function CareerDetails({ pageContext }) {
  const [openPopup, setOpenPopup] = useState(false);
  const [copied, setCopied] = useState(false);
  const uploadedRef = useRef(null);
  const inputErrorRef = useRef(null);
  const inputSuccessRef = useRef(null);
  const uploadedFileRef = useRef(null);
  const uploadedErrorRef = useRef(null);
  const { job: jobsData } = pageContext || {};

  if (!jobsData) {
    return <div>No job data available</div>;
  }
  const {
    content: allContent,
    jobTitle,
    slug,
    meta_title,
    meta_description,
  } = jobsData || {};
  const { location, Experience, content } = allContent || {};

  const handleResumeUpload = (e) => {
    const file = e?.target?.files[0];
    const maxFileSize = 5 * 1024 * 1024;

    if (!file) {
      uploadedErrorRef.current.innerHTML = "Please select a file";
      e.target.value = null;
      uploadedRef.current.innerHTML = null;
      return;
    }

    if (
      file.type !== "application/pdf" &&
      file.type !== "application/msword" &&
      file.type !==
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      uploadedErrorRef.current.innerHTML = "Please upload a PDF,doc,docx file";
      e.target.value = null;
      uploadedRef.current.innerHTML = null;
      return;
    }

    if (file.size > maxFileSize) {
      uploadedErrorRef.current.innerHTML = "File size should be less than 5MB";
      e.target.value = null;
      uploadedRef.current.innerHTML = null;
      return;
    }

    uploadedFileRef.current = file;
    const name =
      file.name.length > 20 ? file.name.substring(0, 18) + "..." : file.name;
    uploadedRef.current.innerHTML = name;
    uploadedErrorRef.current.innerHTML = null;
  };

  const handleResumeSubmit = (e) => {
    e.preventDefault();
    const email = e.target && e.target.email && e.target.email.value;
    const resume = uploadedFileRef.current;
    if (email && resume) {
      inputErrorRef.current.innerHTML = "";
      const submitData = async () => {
        const formData = new FormData();
        formData.append(
          "data",
          JSON.stringify({
            email: email,
            jobTitle,
            location,
            experience: Experience,
          })
        );

        if (
          resume.type === "application/pdf" ||
          resume.type === "application/msword" ||
          resume.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          let key;
          if (resume.type === "application/pdf") {
            key = "files.pdf";
          } else if (resume.type === "application/msword") {
            key = "files.doc";
          } else if (
            resume.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            key = "files.docx";
          }
          formData.append(key, resume, "resume." + resume.type.split("/")[1]);
        } else {
          uploadedErrorRef.current.innerHTML =
            "Please upload a PDF, DOC, or DOCX file";
          return;
        }

        // formData.append("files.pdf", resume, "resume.pdf");

        try {
          const response = await fetch(`${baseUrl}/api/resumes`, {
            method: "POST",
            body: formData,
          });
          if (response?.ok) {
            inputSuccessRef.current.innerHTML =
              "Thank you, we will get back to you!";
          }
        } catch (error) {
          console.error("error: ", error);
        }
      };
      submitData();
    } else {
      inputErrorRef.current.innerHTML = "Resume and email both are required!";
    }
  };
  return (
    <>
      <Seo title={meta_title || "Careers"} description={meta_description} />
      {jobsData && (
        <div className={styles?.CareerDetailsContainer}>
          <BackgroundWave bgColor={"blue"} />
          <div className={styles?.CareerDetailsWrap}>
            <div>
              <div className={styles?.CareerDetailsHeaderWrap}>
                <div className={styles?.CareerDetailsHeader}>
                  <div>
                    <h1 className="title-secondary-sm" style={{ margin: 0 }}>
                      {jobTitle}
                    </h1>
                  </div>
                  <div className={styles?.CareerDetailsLocation}>
                    <span className="banner-secondary-sm ">Location</span>
                    <strong className="banner-secondary-sm ">{location}</strong>
                  </div>
                </div>
                <div className={styles?.shareCopyDiv}>
                  <button
                    className={styles?.shareIcon}
                    onClick={(e) => {
                      handleCopy({
                        text: window?.location.href,
                        onSuccess: () => {
                          setCopied(true);
                          setTimeout(() => {
                            setCopied(false);
                          }, 1500);
                        },
                      });
                    }}
                  >
                    <RenderSvg
                      IconName={copied ? "check" : "copy"}
                      style={{
                        height: "20px",
                        color: "#009bff",
                        pointerEvent: "none",
                      }}
                    />
                  </button>
                  <button
                    className={`${styles?.shareButton} ${styles?.shareIcon}`}
                    onClick={() => setOpenPopup(true)}
                  >
                    <RenderSvg
                      IconName={"share-alt"}
                      style={{ height: "20px", color: "#009bff" }}
                    />
                  </button>
                </div>
              </div>
              <div className={styles?.CareerDetailsExperience}>
                <h2 className="section-title">Experience</h2>
                <p className="overview">{Experience}</p>
              </div>
              <div className={styles?.CareerDetailsContent}>
                {content && (
                  <RichTextRenderer content={content} styles={styles} />
                )}
                <div className={styles?.CareerDetailsCloseBtn}>
                  <Link to="/careers/#jobs-container">
                    <RenderSvg IconName={"times"} style={{ height: "25px" }} />
                  </Link>
                </div>
              </div>
            </div>

            <div className={styles?.CareerDetailsUploads}>
              <label className={styles?.CareerDetailsUploadBtn}>
                <input
                  type="file"
                  name="resume"
                  accept="application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  style={{ display: "none" }}
                  onChange={(e) => handleResumeUpload(e)}
                />
                <div className={styles?.svgContainer}>
                  <RenderSvg
                    IconName={"upload"}
                    style={{
                      height: "25px",
                      color: ScreenSize.isMobile() ? "#009bff" : "#000000",
                    }}
                  />
                </div>
                <div>
                  <h3 className="body-sm fw-700">{"Upload Resume(<5MB)"}</h3>
                  <p ref={uploadedRef}></p>
                  <p
                    style={{
                      color: "#e34f4f",
                      margin: "0.4rem 0rem",
                      fontSize: "0.8em",
                      fontWeight: "bold",
                      letterSpacing: "0.9px",
                    }}
                    ref={uploadedErrorRef}
                  ></p>
                </div>
              </label>
              <div className={styles?.searchBarDiv}>
                <form
                  className={styles?.searchBar}
                  onSubmit={(e) => handleResumeSubmit(e)}
                >
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    required
                  />
                  <button className="mobile-hide" type="submit">
                    Send
                  </button>

                  <div className="desktop-hide">
                    <button
                      type="submit"
                      className="btn"
                      style={{ textDecoration: "none" }}
                    >
                      <RenderSvg
                        IconName={"paper-plane"}
                        style={{ height: "15px", color: "#ffffff" }}
                      />
                    </button>
                  </div>
                </form>
                <p
                  ref={inputErrorRef}
                  style={{
                    color: "#e34f4f",
                    margin: "0.6rem",
                    fontSize: "0.8em",
                    fontWeight: "bold",
                    letterSpacing: "0.9px",
                    display: "block",
                  }}
                ></p>
                <p
                  ref={inputSuccessRef}
                  style={{
                    color: "#2e7b2e",
                    margin: "0.6rem",
                    fontSize: "0.8em",
                    fontWeight: "bold",
                    letterSpacing: "0.7px",
                  }}
                ></p>
              </div>
              <h2 className="title-secondary desktop-hide">
                Current Job Openings
              </h2>
            </div>
          </div>
        </div>
      )}
      <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} share={true} />
    </>
  );
}
